import {useAppSelector} from "../../store/hooks";

/**
 * True while any offer modal is shown. The mobile offer modal has its own filters entry (OfferModalButtons),
 * so the listing underneath must give up the shared filters entry test id until the modal is closed.
 * Mirrors the visibility rule from OfferModal (`isOpen && offerId`).
 */
export const useIsOfferModalOpen = (): boolean => {
    return useAppSelector((state) => Object.values(state.offerModals).some((modal) => modal.isOpen && !!modal.offerId));
};
import {useAppSelector} from "../../store/hooks";

/**
 * True while any offer modal is shown. The mobile offer modal has its own filters entry (OfferModalButtons),
 * so the listing underneath must give up the shared filters entry test id until the modal is closed.
 * Mirrors the visibility rule from OfferModal (`isOpen && offerId`).
 */
export const useIsOfferModalOpen = (): boolean => {
    return useAppSelector((state) => Object.values(state.offerModals).some((modal) => modal.isOpen && !!modal.offerId));
};
